/**
 * Job progression step filter.
 */
export type JobProgressionStepFilterOption =
  (typeof allJobProgressionStepFilterOptions)[number]

/**
 * All job progression step filter options.
 *
 * Saved list settings refer to options by position, so only ever append.
 */
export const allJobProgressionStepFilterOptions = [
  'None',
  'NotStarted',
  'JobStarted',
  'OpenItems',
  'DraftInReview',
  'DraftRejected',
  'DraftApproved',
  'AuthorizationRequested',
  'AuthorizationSigned',
  'ReturnFiled',
  'PreparationCompleted',
  'ReviewCompleted',
  'ExtensionInProgress',
  'ExtensionConfirmed',
  'ExtensionAccepted',
  'ExtensionRejected',
  'WaitingOnClient',
  'ReadyToFile',
] as const
